var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowingUpMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.998 511.998",
    height: 512,
    viewBox: "0 0 511.998 511.998",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m495.475 133.613c5.828-76.02-51.507-120.191-104.985-120.191s-110.813 44.171-104.985 120.191z",
    fill: "#c1a19d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.568 170.193 11.42-11.647 9-13.932-8.914-13.887c-3.468-1.72-7.372-2.691-11.506-2.691-11.024 0-20.435 6.88-24.19 16.579 0 20.742 13.166 25.578 24.19 25.578z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.378 144.614c-1.124 2.904-1.747 6.057-1.747 9.358 0 14.325 11.612 25.937 25.937 25.937 4.099 0 7.973-.954 11.42-2.647l9-8.884-9-9.832c-3.446 1.693-7.321 2.647-11.42 2.647-11.024 0-20.435-6.88-24.19-16.579z",
    fill: "#e8a990"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m507.188 331.484c-13.494-32.472-32.901-53.243-49.487-66.08h-134.422c-16.586 12.837-35.993 33.608-49.487 66.08l116.961 9z",
    fill: "#e5907a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.786 331.484c-1.597 3.843-3.111 7.848-4.528 12.024-1.113 3.281 1.293 6.692 4.758 6.692h232.949c3.465 0 5.872-3.411 4.758-6.692-1.417-4.176-2.932-8.181-4.528-12.024z",
    fill: "#d68474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.49 306.189 26.561-30.384 7.75-28.981h-68.622-.022l8.167 29.682z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.242 320.799 34.466-55.402c-18.124-14.016-32.884-18.573-32.884-18.573l-34.333 59.366 25.795 16.213c2.362 1.485 5.481.765 6.956-1.604z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.739 320.799-34.466-55.402c18.124-14.016 32.884-18.573 32.884-18.573l34.333 59.366-25.795 16.213c-2.362 1.485-5.482.765-6.956-1.604z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.412 170.193-11.42-11.647-9-13.932 8.914-13.887c3.468-1.72 7.372-2.691 11.506-2.691 11.024 0 20.435 6.88 24.19 16.579 0 20.742-13.166 25.578-24.19 25.578z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m503.602 144.614c1.124 2.904 1.747 6.057 1.747 9.358 0 14.325-11.612 25.937-25.937 25.937-4.099 0-7.973-.954-11.42-2.647l-9-8.884 9-9.832c3.446 1.693 7.321 2.647 11.42 2.647 11.024 0 20.435-6.88 24.19-16.579z",
    fill: "#e8a990"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m390.49 245.114c42.803 0 77.503-33.979 77.503-86.502v-24.481c0-42.803-34.699-77.502-77.502-77.502-42.803 0-77.502 34.699-77.502 77.502v24.481c-.001 56.092 34.698 86.502 77.501 86.502z",
    fill: "#fdd4bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.49 195.305c-8.304 15.165-24.515 16.19-32.089 15.757-2.442-.14-4.394-2.055-4.683-4.484-3.891-32.737 20.243-40.665 36.771-40.665 16.529 0 40.663 7.928 36.771 40.665-.289 2.429-2.24 4.345-4.682 4.484-7.572.433-23.784-.592-32.088-15.757z",
    fill: "#c1a19d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.49 236.114c-42.803 0-77.502-34.699-77.502-77.502v18.716c0 42.803 34.699 77.502 77.502 77.502 42.803 0 77.503-34.699 77.503-77.502v-18.716c0 42.803-34.7 77.502-77.503 77.502z",
    fill: "#f7c4a8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.746 166.222c0 16.216 11.679 22.715 21.09 22.715l10.159-11.355 9-11.36-9-11.36c-3.066-1.506-6.513-2.355-10.159-2.355-9.411 0-17.5 5.636-21.09 13.715z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.746 166.222c-1.271 2.861-1.984 6.025-1.984 9.358 0 12.743 10.33 23.073 23.073 23.073 3.646 0 7.093-.849 10.159-2.355l9-9.222-9-9.494c-3.066 1.506-6.513 2.355-10.159 2.355-9.41 0-17.499-5.637-21.089-13.715z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.966 331.621c-25.324-58.889-72.484-73.442-72.484-73.442h-.02c-9.203 4.552-19.561 7.122-30.523 7.122-10.962 0-21.32-2.57-30.523-7.122h-.019s-47.16 14.553-72.484 73.442l103.029 9z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.917 331.621c-1.644 3.822-3.197 7.828-4.639 12.03-1.123 3.273 1.304 6.687 4.764 6.687h205.795c3.46 0 5.888-3.414 4.764-6.687-1.442-4.202-2.996-8.207-4.639-12.03z",
    fill: "#e84642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.133 166.222c0 16.216-11.679 22.715-21.089 22.715l-10.159-11.355-9-11.36 9-11.36c3.066-1.506 6.513-2.355 10.159-2.355 9.41 0 17.499 5.636 21.089 13.715z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.133 166.222c1.271 2.861 1.984 6.025 1.984 9.358 0 12.743-10.33 23.073-23.073 23.073-3.646 0-7.093-.849-10.159-2.355l-9-9.222 9-9.494c3.066 1.506 6.513 2.355 10.159 2.355 9.41 0 17.499-5.637 21.089-13.715z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.939 255.585c38.077 0 68.945-26.37 68.945-77.945v-34.466l-68.943-9.716-68.948 9.716v34.466c.001 51.576 30.869 77.945 68.946 77.945z",
    fill: "#fdd4bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.942 300.056c29.238 0 30.54-41.877 30.54-41.877h-.02-61.046-.015c.001 0 1.303 41.877 30.541 41.877z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.099 124.458c-8.369-56.247-40.827-73.957-79.159-73.957s-70.79 17.71-79.159 73.957l79.161 9z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.774 124.458c-.628 4.223-1.12 8.664-1.469 13.331-.218 2.91 2.108 5.386 5.026 5.386h47.838l27.771-9.716 27.771 9.716h47.838c2.918 0 5.243-2.475 5.026-5.385-.349-4.667-.841-9.107-1.469-13.331h-158.332z",
    fill: "#e84642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.939 246.585c-38.077 0-68.945-30.868-68.945-68.945v18.716c0 38.077 30.868 68.945 68.945 68.945 38.077 0 68.945-30.868 68.945-68.945v-18.716c.001 38.078-30.867 68.945-68.945 68.945z",
    fill: "#f7c4a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.71 112.398v-3.35c0-15.337-12.433-27.771-27.771-27.771s-27.771 12.434-27.771 27.771v3.35l27.773 9z",
    fill: "#5a5b77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.71 124.458-27.768 9-27.773-9v-12.06h55.541z",
    fill: "#cb3541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.169 124.458h55.542v18.716h-55.542z",
    fill: "#b53939"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m481.125 410.349-88.55-21.705c-3.923-.961-7.325 2.853-5.922 6.641l5.92 15.987s-124.035 65.901-354.87-7.858c-3.063-.979-5.825-.612-8.06.571 76.179 59.835 220.23 115.058 379.62 63.272l6.797 7.444 7.623 20.586c1.434 3.872 6.661 4.469 8.93 1.02l51.519-78.297c1.914-2.908.372-6.833-3.007-7.661z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m409.264 458.257c-159.39 51.786-300.828-7.235-379.62-54.272-6.439 3.409-8.479 13.645-.53 18.402 79.802 47.755 224.432 108.172 386.947 52.314v-11.505c0-3.528-3.443-6.029-6.797-4.939z",
    fill: "#e84642"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m425.153 156.672c4.315 0 7.814-3.498 7.814-7.814v-12.577c0-4.315-3.498-7.814-7.814-7.814-4.315 0-7.814 3.498-7.814 7.814v12.577c.001 4.316 3.499 7.814 7.814 7.814z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.353 156.672c4.315 0 7.814-3.498 7.814-7.814v-12.577c0-4.315-3.498-7.814-7.814-7.814s-7.814 3.498-7.814 7.814v12.577c0 4.316 3.499 7.814 7.814 7.814z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.055 108.221c-4.315 0-7.814 3.498-7.814 7.814 0 4.315 3.498 7.814 7.814 7.814h21.397c4.315 0 7.814-3.498 7.814-7.814 0-4.315-3.498-7.814-7.814-7.814z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.108 97.773h31.29c4.315 0 7.814-3.498 7.814-7.814s-3.498-7.814-7.814-7.814h-31.29c-4.315 0-7.814 3.498-7.814 7.814s3.499 7.814 7.814 7.814z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.252 190.3c4.315 0 7.814-3.498 7.814-7.814v-11.189c0-4.315-3.498-7.814-7.814-7.814-4.315 0-7.814 3.498-7.814 7.814v11.189c0 4.316 3.498 7.814 7.814 7.814z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.048 190.3c4.315 0 7.814-3.498 7.814-7.814v-11.189c0-4.315-3.498-7.814-7.814-7.814s-7.814 3.498-7.814 7.814v11.189c0 4.316 3.498 7.814 7.814 7.814z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.545 219.249c2.192 5.325 9.947 14.337 25.104 14.337s22.912-9.012 25.104-14.337c1.643-3.99-.26-8.557-4.25-10.2-3.991-1.645-8.557.259-10.2 4.25-.019.046-2.294 4.659-10.654 4.659s-10.635-4.613-10.654-4.659c-1.643-3.991-6.209-5.895-10.2-4.25-3.99 1.643-5.893 6.21-4.25 10.2z",
    fill: "#f95750"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingUpMan);
export default __webpack_public_path__ + "static/media/growing-up-man.5024153b1b81cd13bdb8e51fd323551f.svg";
export { ForwardRef as ReactComponent };